import { AbstractControl, ValidatorFn } from '@angular/forms';

export function maxValidator(max: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const value = parseFloat(control.value);
        return !isNaN(value) && value > max ? { 'maxValueValidation': { max: max } } : null;
    };
}